import type { InvalidParams } from '../features/validation';

export class ResponseBodyValidationError extends Error {
  public invalidParams: InvalidParams | undefined;

  static {
    this.prototype.name = 'ResponseBodyValidationError';
  }

  constructor(error = '', options: { invalidParams?: InvalidParams } = {}) {
    const { invalidParams, ...rest } = options;

    super(error, rest);
    this.invalidParams = invalidParams;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
